import Pusher from 'pusher-js';

declare global {
    interface Window {
        pusherClient: Pusher;
    }
}

export function getPusherClient() {
    // Check if window object is available
    if (typeof window === 'undefined') {
        return null;
    }

    // Check if pusherClient is already initialized
    if (window.pusherClient) {
        return window.pusherClient;
    }

    window.pusherClient = new Pusher(process.env['NEXT_PUBLIC_PUSHER_KEY']!, {
        cluster: process.env['NEXT_PUBLIC_PUSHER_CLUSTER']!
    });

    return window.pusherClient;
}
